import type { SecoesMenuProps } from "./types-secoes-menu";
import { useSecoesMenu } from "./use-secoes-menu";
import { SecoesMenuView } from "./view-secoes-menu";

/**
 * Menu das seções de um corpo rolável (detalhe da embarcação e ficha financeira): lateral no desktop, com a trilha e o
 * item ativo, e seletor "Seção: …" no mobile. Quem rola o corpo é `useSecoesScroll`.
 */
export function SecoesMenu(props: SecoesMenuProps) {
  const vm = useSecoesMenu(props);

  return <SecoesMenuView {...vm} />;
}

export type * from "./types-secoes-menu";
